import { createBrowserRouter, Navigate } from "react-router-dom";
import loginRoutes from "./login-routes";
import mainRoutes from "./main-routes";
import { routes } from ".";
import { localStorageItemNames } from "../common/constants";
import { Cookies } from "react-cookie";

const AuthRedirect = () => {
    const cookies = new Cookies();
    const token = cookies.get(localStorageItemNames.TOKEN);

    if (!token) return <Navigate to={routes.LOGIN} replace />;

    return <Navigate to={routes.DASHBOARD} replace />;
};

const router = createBrowserRouter([
    {
        path: "/",
        element: <AuthRedirect />
    },
    loginRoutes,
    mainRoutes
]);

export default router;
